import { render, staticRenderFns } from "./MainWindow.vue?vue&type=template&id=8433161e"
import script from "./MainWindow.vue?vue&type=script&lang=js"
export * from "./MainWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports